import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "90",
  height: "100",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("g", {
      fill: "currentColor",
      "fill-rule": "nonzero"
    }, [
      _createElementVNode("path", { d: "M89.798 0H.202v90.2h89.596V0Zm-3.201 3.2V87H3.401V3.2h83.196Z" }),
      _createElementVNode("path", { d: "m25.97.814 63.302 57.27-2.147 2.373-63.302-57.27z" }),
      _createElementVNode("path", { d: "m55.415 29.505 2.265 2.26L3.213 86.35l-2.265-2.26zM3.402 88.6V100h-3.2V88.6zM89.798 67.326V100h-3.2V67.326z" })
    ], -1)
  ])))
}
export default { render: render }